import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 15381 17995"
    {...props}
  >
    <path
      d="M2233 0h4750c1235 0 2295 113 3179 344 888 230 1688 661 2408 1290 1873 1604 2811 4046 2811 7317 0 1081-92 2065-281 2957-188 893-481 1697-871 2413-394 716-896 1357-1512 1923-482 431-1010 779-1583 1038-574 264-1190 449-1848 553-657 105-1403 160-2228 160H2308c-662 0-1160-101-1500-302-335-201-552-482-653-846-105-365-155-838-155-1416V2233C0 1449 176 880 528 528S1449 0 2233 0zm1411 2890v12215h2765c603 0 1081-17 1424-51 344-33 699-113 1068-243 369-134 687-318 955-553 1219-1030 1831-2806 1831-5328 0-1776-268-3108-805-3991-536-884-1198-1446-1981-1688-787-239-1738-361-2848-361H3644z"
      style={{
        fill: "#2b2a29",
        fillRule: "nonzero",
      }}
      className="fill"

    />
  </svg>
)
export default SvgComponent
